import React from 'react'
import { IconProps } from './icons.models'

export const AttachmentIcon: React.FC<IconProps> = ({
    width = 15,
    height = 16,
    className,
    onClick,
    fillColor = '#3EAE54',
}) => {
    return (
        <svg width={width} height={height} className={className} onClick={onClick} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.6073 7.09187L7.48066 13.2185C6.7301 13.9691 5.71212 14.3908 4.65066 14.3908C3.58921 14.3908 2.57122 13.9691 1.82066 13.2185C1.0701 12.468 0.648438 11.45 0.648438 10.3885C0.648438 9.32708 1.0701 8.3091 1.82066 7.55854L7.94733 1.43187C8.4477 0.931498 9.12636 0.650391 9.83399 0.650391C10.5416 0.650391 11.2203 0.931498 11.7207 1.43187C12.221 1.93225 12.5021 2.6109 12.5021 3.31854C12.5021 4.02618 12.221 4.70483 11.7207 5.20521L5.58733 11.3319C5.46345 11.4558 5.31638 11.554 5.15452 11.6211C4.99267 11.6881 4.81919 11.7226 4.644 11.7226C4.4688 11.7226 4.29532 11.6881 4.13347 11.6211C3.97161 11.554 3.82454 11.4558 3.70066 11.3319C3.57678 11.208 3.47851 11.0609 3.41147 10.8991C3.34443 10.7372 3.30992 10.5637 3.30992 10.3885C3.30992 10.2133 3.34443 10.0399 3.41147 9.87801C3.47851 9.71615 3.57678 9.56909 3.70066 9.44521L9.36066 3.79187" stroke={fillColor} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
